/**
 * @generated SignedSource<<4cbe2d9a6a553fb301fef28eb01bf740>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BannerContent$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"BannerAnnouncement">;
  } | null | undefined;
  readonly " $fragmentType": "BannerContent";
};
export type BannerContent$key = {
  readonly " $data"?: BannerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BannerContent",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "BannerAnnouncement"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "8e43137c911d52aa8f2b5b3266772ead";

export default node;
